import React from 'react';
import { Handle, useHandleConnections, useNodeConnections } from '@xyflow/react';

const CustomHandle = ({ connectionCount = Infinity, ...props }) => {
    const connections = useNodeConnections({
        type: props.type,
    });

    return (
        <Handle
            {...props}
            isConnectable={connections.length < connectionCount}
        />
    );
};

export default CustomHandle;
